var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Q2",
    "data-name": "icons Q2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.174,
    height: 30,
    viewBox: "0 0 23.174 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M18.587,2C11.839,2,7,7.521,7,14.268S14.838,28.786,17.633,31.58a1.295,1.295,0,0,0,1.908,0c2.794-2.794,10.633-10.428,10.633-17.312S25.334,2,18.587,2Zm0,14.995a4.771,4.771,0,1,1,4.771-4.771A4.771,4.771,0,0,1,18.587,16.995Z",
    transform: "translate(-7 -2)",
    fill: "#a1a1b3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinIcon);
export default __webpack_public_path__ + "static/media/LocationPinIcon.5cd905dfe528500ba43bba4d71d8a3b2.svg";
export { ForwardRef as ReactComponent };